import {IssueType} from "@server-models";
import {Route} from "@angular/router";

export const createIssueDetailChildren = (issueType: IssueType): Route[] =>
  [
    {
      path: '',
      redirectTo: 'detail',
      pathMatch: 'full'
    },
    {
      path: 'detail',
      loadComponent: () => import('@shared/components/issues/pages/detail/shared-issue-detail.page').then(m => m.SharedIssueDetailPage),
      data: {
        issueType
      }
    },
    {
      path: 'chat',
      loadComponent: () => import('@shared/components/issues/pages/chat/shared-issue-chat-page').then(m => m.SharedIssueChatPage),
      data: {
        issueType
      }
    },
    {
      path: '**',
      redirectTo: 'detail'
    },
  ];

export const getSharedIssueRoutes = (): Route[] =>
  [
    {
      path: 'issues/:contentType/create/:templateId/success',
      loadComponent: () => import('@shared/components/issues/pages/success/shared-issue-success.page').then(m => m.SharedIssueSuccessPage),
    },
    {
      path: 'issues/:contentType/create/:templateId',
      loadComponent: () => import('@shared/components/issues/pages/create/shared-issue-create.page').then(m => m.SharedIssueCreatePage),
    },
    {
      path: 'issues/create/:templateId',
      loadComponent: () => import('@shared/components/issues/pages/create/shared-issue-create.page').then(m => m.SharedIssueCreatePage),
    },
    {
      path: 'issues/message/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.Message,
      },
      children: createIssueDetailChildren(IssueType.Message)
    },
    {
      path: 'issues/direct-message/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.DirectMessage,
      },
      children: createIssueDetailChildren(IssueType.DirectMessage)
    },
    {
      path: 'issues/mission/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.Mission,
      },
      children: createIssueDetailChildren(IssueType.Mission)
    },
    {
      path: 'issues/ticket/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.Ticket,
      },
      children: createIssueDetailChildren(IssueType.Ticket)
    },
    {
      path: 'issues/control-message/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.ControlMessage,
      },
      children: createIssueDetailChildren(IssueType.ControlMessage)
    },
    {
      path: 'issues/connected/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.Connected,
      },
      children: createIssueDetailChildren(IssueType.Connected)
    },
    {
      path: 'issues/winterhalter-product-order/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.WinterhalterProductOrder,
      },
      children: createIssueDetailChildren(IssueType.WinterhalterProductOrder)
    },
    {
      path: 'issues/winterhalter-service-call/:issueId',
      loadComponent: () => import('@shared/components/issues/pages/id/shared-issue-id-page').then(m => m.SharedIssueIdPage),
      data: {
        issueType: IssueType.WinterhalterServiceCall,
      },
      children: createIssueDetailChildren(IssueType.WinterhalterServiceCall)
    },
    {
      path: 'issues/templates',
      loadComponent: () => import('@shared/components/issues/pages/template-list/shared-issue-template-list.page').then(m => m.SharedIssueTemplateListPage)
    },
    {
      path: '**',
      redirectTo: 'issues'
    }
  ];
